import React from "react";
import { Button, Card, Col, Empty, Row, Spin } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useWishlist } from "contexts/WishlistContext";
import Helpers from "@utils/Helpers";
import "./Watchlist.scss";

const defaultImg =
  "https://hopeful-luck-fc0d448ef2.media.strapiapp.com/default_0a174d27c8.jpeg";

const Watchlist: React.FC = () => {
  const { items, remove, isLoading, hasError } = useWishlist();
  const navigate = useNavigate();

  const handleRemove = async (event: React.MouseEvent, productId: number) => {
    event.stopPropagation();
    await remove(productId);
  };

  if (isLoading) {
    return (
      <div className="Watchlist">
        <div className="watchlist-state" data-testid="watchlist-loading">
          <Spin />
        </div>
      </div>
    );
  }

  if (hasError) {
    return (
      <div className="Watchlist">
        <Empty description="Can't load your watchlist" />
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="Watchlist">
        <Empty description="No products in your watchlist" />
      </div>
    );
  }

  return (
    <div className="Watchlist">
      <div className="watchlist-title">Watchlist</div>
      <Row gutter={[16, 16]}>
        {items.map((item) => (
          <Col key={item.product_id} xs={24} sm={12} lg={8}>
            <Card
              hoverable
              className="watchlist-card"
              onClick={() =>
                navigate(`/product/detail?productId=${item.product_id}`)
              }
              cover={
                <img
                  alt={item.name ?? "Watchlist product"}
                  src={item.image_url || defaultImg}
                  className="watchlist-image"
                />
              }
            >
              <Card.Meta
                title={item.name ?? "Product"}
                description={`$${Helpers.formatNumber(item.price ?? 0, 2)}`}
              />
              <Button
                danger
                icon={<DeleteOutlined />}
                className="watchlist-remove"
                aria-label={`Remove ${item.name ?? "product"} from watchlist`}
                onClick={(event) => handleRemove(event, item.product_id)}
              >
                Remove
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Watchlist;
